import * as React from "react";
import GeneralSelect from "../general_select";
import PopDetail from "../popdetail";
import {ProjectsService} from "../../service/v1/projects";
import Wait from "../wait";
import uncheck from "../../resources/img/checkbox/checkbox_unchecked.png";
import check from "../../resources/img/checkbox/checkbox_checked.png";
import {PDFViewer} from '@react-pdf/renderer';
import {Page, Text, View, Document, StyleSheet} from '@react-pdf/renderer';
import BillDetails from "../v1/report/templates/bill_details";
import {useRef} from "react";
import jsPDF from "jspdf";

export default class BillDetailsPane extends React.Component {

    constructor(props) {
        super(props);
        this.reportTemplateRef = React.createRef();
        this.generatePdf = this.generatePdf.bind(this)
    }

    render() {

        return (<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding: 0, width: "100%", height: '80vh', overflow: "auto",
                overflowX:'hidden',  alignContent: "center"}}>

                <div style={{width: "100%", height: "90vh", marginLeft : '10%', marginTop: '0%'}}>
                    <button className="btn-list" style={{marginLeft:'2%'}} onClick={this.generatePdf}>
                        Generate PDF
                    </button>
                    <div ref={this.reportTemplateRef}>
                        <BillDetails projects={this.props.projects} checkout_total={this.props.checkout_total}/>
                    </div>
                </div>

               {/* */}
            </div>
        </div>)
    }


    generatePdf() {
        /*const doc = new jsPDF({
            format: 'a4',
            unit: 'px',
        });*/
        const doc = new jsPDF('p', 'pt', 'a4');

        // Adding the fonts.
        doc.setFont('Inter-Regular', 'normal');
        let billPrint = this.reportTemplateRef.current
        console.log(billPrint)
        doc.html(billPrint, {
            async callback(doc) {
                await doc.save('document');
            },
        });
    }

}